<template>
  <div style="padding: 40px;">
    <h2>第三方设备模拟器（TUICallEngine 方式）</h2>
    <el-form label-width="120px">
      <el-form-item label="SDKAppID">
        <el-input v-model="form.sdkAppID" />
      </el-form-item>
      <el-form-item label="第三方UserID">
        <el-input v-model="form.fromUserId" placeholder="如 device_001" />
      </el-form-item>
      <el-form-item label="医生UserID">
        <el-input v-model="form.toUserId" placeholder="接收方医生的 baseUserId" />
      </el-form-item>
      <el-form-item label="患者编码">
        <el-input v-model="form.patientCode" />
      </el-form-item>
      <el-form-item label="诊断编码">
        <el-input v-model="form.diagRecordCode" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="login">登录 TUICallEngine</el-button>
        <el-button type="success" :disabled="!isLogin" @click="callVideo">发起视频呼叫</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import TencentCloudChat from '@tencentcloud/chat'
import { TUICallEngine } from '@trtc/call-engine-lite-js'
import { getData } from '@/api/user/authApi'

export default {
  data() {
    return {
      form: {
        sdkAppID: 1400539979,
        fromUserId: 'device_001',
        toUserId: '',
        patientCode: 'P20240001',
        diagRecordCode: 'D20240001'
      },
      tim: null,
      tuicall: null,
      isLogin: false
    }
  },

  beforeDestroy() {
    // 页面关闭时清理
    if (this.tuicall) {
      this.tuicall.hangup?.()
      this.tuicall = null
    }
    if (this.tim) {
      this.tim.logout?.()
      this.tim = null
    }
  },
  methods: {
    async login() {
      // 1. 创建 TIM 实例
      this.tim = TencentCloudChat.create({ SDKAppID: Number(this.form.sdkAppID) })
      this.tim.setLogLevel(1)

      // 2. 获取 UserSig（需要后端允许该账号生成签名）
      const res = await getData('base/user/user/user/get/getUserSig', 'get', {
        baseUserId: this.form.fromUserId
      })
      const userSig = res.data?.userSig || res.data?.data?.userSig

      // 3. TIM 登录
      await this.tim.login({ userID: String(this.form.fromUserId), userSig })

      // 4. 初始化 TUICallEngine（Web 版必须复用已登录的 TIM 实例）
      this.tuicall = TUICallEngine.createInstance({
        SDKAppID: Number(this.form.sdkAppID),
        tim: this.tim
      })

      // 5. TUICallEngine 登录
      await this.tuicall.login({
        userID: String(this.form.fromUserId),
        userSig
      })

      this.isLogin = true
      this.$message.success('TUICallEngine 登录成功')
    },

    async callVideo() {
      if (!this.tuicall) return
      try {
        // 发起视频通话（和 App 端 TUICallKit 完全同协议）
        await this.tuicall.call({
          userID: String(this.form.toUserId),
          type: 2, // 2 = 视频通话（1=语音）
          userData: this.form.diagRecordCode // 扩展字段，对方在 ON_CALL_RECEIVED 中通过 userData 获取
        })
        this.$message.success('视频呼叫已发起（TUICallEngine）')
      } catch (err) {
        console.error('呼叫失败', err)
        this.$message.error('呼叫失败: ' + (err.message || err))
      }
    }
  }
}
</script>
